import Swiper from 'swiper/bundle';

export class ProductSpot {
  constructor(element) {
    this._refs = {
      el: element,
    };
    this.swiperItems = [...element.querySelectorAll('.product-deck__item')];
    this._options = { ...this.settings };
    this.init();
  }

  init() {
    this._getCustomOptions();
    this._runSwiperSlide();
  }

  _getCustomOptions() {
    this._options['slidesPerView'] =
      this._refs.el.dataset?.slidesPerView || this._options['slidesPerView'];
    this._options['mobileViewport'] =
      this._refs.el.dataset?.mobileViewport || this._options['mobileViewport'];
    if (this._refs.el.dataset?.loop) {
      this._options['loop'] = JSON.parse(this._refs.el.dataset?.loop);
    }
  }

  get _viewportWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth,
    );
  }

  get _checkIfSwiperShouldInitialize() {
    // If mobile viewport
    if (this._options['mobileViewport'] > this._viewportWidth) return true;
    // If items are less or equal slidesPerView
    if (this.swiperItems.length <= this._options['slidesPerView']) return false;
    return true;
  }

  _runSwiperSlide() {
    if (!this._checkIfSwiperShouldInitialize) return;
    this._refs.el.classList.remove('disabled_swiper');
    new Swiper(this._refs.el, this._options);
  }

  get settings() {
    return {
      speed: 600,
      spaceBetween: 30,
      loop: true,
      loopFillGroupWithBlank: false,
      slidesPerView: 5,
      mobileViewport: 769,
      navigation: {
        nextEl: this._refs.el.querySelector('.button-next'),
        prevEl: this._refs.el.querySelector('.button-prev'),
      },
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        500: {
          slidesPerView: 2,
        },
        680: {
          slidesPerView: 3,
        },
        1000: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 5,
        },
      },
    };
  }
}
